// ============================================================================
// USER ACCESS SERVICE — Settings → User Access: a user's roles and the entities,
// business units and financial years they may work in. Login stays with
// Keycloak / tenant-hub; a user is listed after their first login.
// ============================================================================

import { get, put } from '../client/axiosClient';
import { userAccessEndpoints } from '../endpoints/iam.endpoints';
import type { AccessOptionsDto, ApiResponse, SaveUserAccessRequest, UserAccessDetailDto, UserAccessSummaryDto } from '../types';

class UserAccessService {
  async getUsers(): Promise<UserAccessSummaryDto[]> {
    const r = await get<ApiResponse<UserAccessSummaryDto[]>>(userAccessEndpoints.users());
    return r.data.data ?? [];
  }

  /** Roles, and the entities / BUs / years the signed-in editor may hand out. */
  async getOptions(): Promise<AccessOptionsDto> {
    const r = await get<ApiResponse<AccessOptionsDto>>(userAccessEndpoints.options());
    return r.data.data;
  }

  async getUser(id: string): Promise<UserAccessDetailDto> {
    const r = await get<ApiResponse<UserAccessDetailDto>>(userAccessEndpoints.user(id));
    return r.data.data;
  }

  /** Replaces the user's roles and access (empty = no access). */
  async save(id: string, data: SaveUserAccessRequest): Promise<UserAccessDetailDto> {
    const r = await put<ApiResponse<UserAccessDetailDto>>(userAccessEndpoints.user(id), data);
    return r.data.data;
  }
}

export const userAccessService = new UserAccessService();
